/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_Offline_Recording_DeviceInputs */



/**
* | output |
* | --- |
* | "Microphone: {name}" |
*
* @param {Meeting_Offline_Recording_DeviceInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_recording_device = /** @type {((inputs: Meeting_Offline_Recording_DeviceInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Recording_DeviceInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Micro: ${i?.name}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Micro : ${i?.name}`)
	return /** @type {LocalizedString} */ (`Microphone: ${i?.name}`)
});